module.exports = "/_next/static/images/download-e3c9d1ef42eda120783009971cba5083.svg";